import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber, formatDate, formatPhoneNumber} from "page/util/helpers";

function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";

    const navigate = useNavigate();

    const requestSearch = (e) => {
        const params = {};
        params.page = page;

        axios.get(`/admin/biz/membership-cancel/histories`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">멤버십 취소 이력 > 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>

                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>비즈ID</th>
                                                    <th>사업자번호</th>
                                                    <th>사업장명</th>
                                                    <th>취소일</th>
                                                    <th>사유</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.bizId}</td>
                                                                <td>{formatBusinessNumber(item.bizNo)}</td>
                                                                <td>{item.bizName}</td>
                                                                <td>{formatDate( item.createdAt)}</td>
                                                                <td>{item.reason}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}

export default Main;
